import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { getBrand, getBrandConfig, getEnvironment, initializeSentry } from '@shared/services';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import packageInfo from '../package.json';

initializeSentry('rocketkor-admin-portal@' + packageInfo.version);

const brandConfig = getBrandConfig();
document.documentElement.setAttribute('data-brand', getBrand());
document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', brandConfig.favicon);
document.title = brandConfig.displayName;

if (getEnvironment().production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
